import { BaseChordType, KeyNote } from "./chord-logic/baseChordTypes";

export const DEFAULT_KEY = KeyNote.C;
export const DEFAULT_FIRST_CHORD = BaseChordType.IMaj7;
